import { render, staticRenderFns } from "./StepDefineResponsible.vue?vue&type=template&id=8ba5a120&scoped=true&"
import script from "./StepDefineResponsible.vue?vue&type=script&lang=js&"
export * from "./StepDefineResponsible.vue?vue&type=script&lang=js&"
import style0 from "./StepDefineResponsible.vue?vue&type=style&index=0&id=8ba5a120&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ba5a120",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VAlert,VBtn})
